module.exports = __webpack_public_path__ + "static/media/info.f6efe44a.gif";